if (!customElements.get('pastael-gifting-nav')) {
  class PastaelGiftingNav extends HTMLElement {
    connectedCallback() {
      this.shopAllAnchorId = (this.dataset.shopAllAnchor || 'shop_all').trim();
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const link = event.target.closest('[data-gifting-nav]');
      if (!link || !this.contains(link)) return;
      event.preventDefault();

      const anchorId = (link.dataset.targetAnchor || '').trim();
      const filterId = (link.dataset.productFilter || '').trim();

      if (filterId) {
        this.applyShopAllFilter(filterId);
      }

      if (anchorId) {
        this.scrollToAnchor(anchorId);
      }
    }

    applyShopAllFilter(filterId) {
      const shopAll = this.findShopAllSection();
      if (shopAll && typeof shopAll.setFilter === 'function') {
        shopAll.setFilter(filterId);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('pastael-gifting:apply-filter', {
          detail: {
            sectionKey: this.shopAllAnchorId,
            filterId,
          },
        })
      );
    }

    findShopAllSection() {
      return document.querySelector(
        `pastael-gifting-shop-all[data-scroll-anchor="${PastaelGiftingNav.escapeAttr(this.shopAllAnchorId)}"]`
      );
    }

    scrollToAnchor(anchorId) {
      const target = PastaelGiftingNav.resolveScrollTarget(anchorId);
      if (!target) return;

      const header =
        document.querySelector('.section-header') ||
        document.querySelector('sticky-header') ||
        document.querySelector('header');
      const offset = (header?.offsetHeight || 0) + 12;

      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    static resolveScrollTarget(anchorId) {
      if (!anchorId) return null;

      return (
        document.getElementById(anchorId) ||
        document.querySelector(`[data-scroll-anchor="${PastaelGiftingNav.escapeAttr(anchorId)}"]`) ||
        document.querySelector(`.shopify-section[id$="__${PastaelGiftingNav.escapeAttr(anchorId)}"]`)
      );
    }

    static escapeAttr(value) {
      if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        return CSS.escape(String(value));
      }
      return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }
  }

  customElements.define('pastael-gifting-nav', PastaelGiftingNav);
}
